import { authRequest } from './utils';


/**
 * fetchThreadsByContact :: (Number, String, Object) -> Promise Error Object
 */
export const fetchThreadsByContact = (page, contactId, cancelToken) =>
  authRequest({
    method: 'GET',
    url: `/gmail/threads/contact/${contactId}`,
    cancelToken,
    params: {
      page,
    },
  })
    .then(({ data }) => data);


/**
 * fetchThreadMessages :: Object -> Promise Error Object
 */
export const fetchThreadMessages = ({ page, threadId, cancelToken }) =>
  authRequest({
    method: 'GET',
    url: `/gmail/threads/${threadId}`,
    cancelToken,
    params: {
      page,
    },
  })
    .then(({ data }) => data);



// WEBPACK FOOTER //
// ./src/api/apiko-api/gmail.js